import { z } from "zod/v4";

export const handleMarketingEmailUnsubscribeSchema = {
  name: "handleMarketingEmailUnsubscribe" as const,
  input: z.object({
    token: z.string(),
    campaignId: z.string().optional(),
    automationId: z.string().optional(),
    automationStepId: z.string().optional(),
    templateId: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
